export enum SourcePages {
  SeoSrp = 'seo_srp',
  Srp = 'srp',
  SeoSrpFilter = 'seo_srp_filter',
  SrpFilter = 'srp_filter',
  SrpLeadForm = 'srp_lead_form',
  SeoSrpQuickPicks = 'seo_srp_quick_picks',
  SrpQuickPicks = 'srp_quick_picks',
  VdpPhotoSlideshow = 'vdp_photo_slideshow',
  VdpQuickPicks = 'vdp_quick_picks',
  Vdp = 'vdp',
  Home = 'home_page',
  GuidesLanding = 'guides_landing',
  PaidLandingTest = 'paid_landing_test',
  DealerPage = 'dealer_page',
  Favorites = 'favorites',
  VdpModalLeadForm = 'vdp_modal_lead_form',
  LeadFeedbackSurvey = 'lead_feedback_survey',
  ThankYouPage = 'lead_feedback_thank_you',
  GuidesReviews = 'guides_reviews',
  SeoSrpMonthlyPaymentBasis = 'seo_srp_monthly_payment_basis',
  SrpMonthlyPaymentBasis = 'srp_monthly_payment_basis',
  Listings = 'listings',
  OnboardingExit = 'onboarding_exit',
  OnboardingLocation = 'onboarding_location',
  OnboardingCondition = 'onboarding_condition',
  OnboardingYear = 'onboarding_year_range',
  OnboardingMileage = 'onboarding_max_miles',
  OnboardingFuelType = 'onboarding_fuel_type',
  OnboardingPriceRange = 'onboarding_price_range',
  OnboardingBodyStyle = 'onboarding_body_style',
}

export enum Features {
  category = 'category_filter',
  condition = 'condition',
  transmission = 'transmission',
  drivetrain = 'drivetrain',
  featuresTechnology = 'features_technology',
  makeModelTrim = 'make_model_trim',
  fuelEfficiency = 'fuel_efficiency_range',
  bed = 'bed',
  doors = 'doors',
  bodyTypes = 'body_types',
  bodyStyles = 'body_styles',
  advanced = 'advanced',
  cabinType = 'cabin_type',
  rearWheel = 'rear_wheel',
  bedType = 'bed',
  makeModel = 'make_model',
  cityZip = 'city_zip',
  locationRadius = 'location_radius',
  color = 'color',
  exteriorColor = 'exterior_color',
  interiorColor = 'interior_color',
  powertrain = 'powertrain',
  cylinders = 'cylinders',
  listingCard = 'listing_card',
  noVehiclesFound = 'no_vehicles_found',
  slideshow = 'slideshow',
  PaidFlow = 'paid_flow',
  modalLeadForm = 'modal_lead_form',
  Favorites = 'favorites',
  warranty = 'warranty',
  buyerIntelligence = 'buyer_intelligence',
  footerNav = 'footer_nav',
  keyFeatures = 'key_features',
  navBar = 'nav_bar',
  sellerSnapshot = 'seller_snapshot',
  vehicleSnapshot = 'vehicle_snapshot',
  stickyCta = 'sticky_cta',
  similarListings = 'similar_listings',
  leadForm = 'lead_form',
  quickPicks = 'quick_picks',
  legacySearch = 'legacy_search',
  keywordSearch = 'keyword_search',
  setLocation = 'set_location',
  leadFeedback = 'lead_feedback',
  emailSignUpModal = 'email_sign_up_modal',
  engine = 'engine',
  mileage = 'mileage_range',
  year = 'year_range',
  price = 'price_range',
  srpHeader = 'srp_header',
  noPrice = 'no_price',
  monthlyPayment = 'monthly_payment_basis',
  linkBank = 'link_bank',
  news = 'news',
  topDealer = 'top_dealer',
  miniVdpModal = 'mini_vdp_modal',
  onboarding = 'onboarding_survey',
  srpTile = 'srp_tile',
}

export enum ViewTypes {
  pageView = 'page_view',
  modalView = 'modal_view',
  modalClose = 'modal_close',
}

export enum EventType {
  view = 'view',
  sessionStarted = 'session_started',
  socialShare = 'social_share',
  leadFeedbackResponse = 'lead_feedback_response',
  contentEngagement = 'content_engagement',
  homepageEngagement = 'homepage_engagement',
  dealerPageEngagement = 'dealer_page_engagement',
  engagement = 'engagement',
  navbarEngagement = 'navbar_engagement',
  action = 'action',
  listingImpression = 'listing_impression',
  appEvent = 'app_event',
  // fix for old event ontology, not to be used going forward
  pageView = 'page_view',
  api = 'api',
  cwvCLS = 'cwv_cls',
  cwvFCP = 'cwv_fcp',
  cwvFID = 'cwv_fid',
  cwvLCP = 'cwv_lcp',
  cwvTTFP = 'cwv_ttfb',
}

export enum ImpressionType {
  srpResult = 'srp_result',
  vdpView = 'vdp_view',
  quickPicksView = 'quick_picks_view',
  quickPicksResult = 'quick_picks_result',
}

export const DealerPagesEventType = {
  google_maps_click: 'google_maps_click',
  view_listings_button_click: 'view_listings_button_click',
  read_reviews_button_click: 'read_reviews_button_click',
  call_dealership_click: 'call_dealership_click',
  email_click: 'email_click',
  get_directions_click: 'get_directions_click',
  website_click: 'website_click',
  share_click: 'share_click',
  contact_autolist_click: 'contact_autolist_click',
  write_a_review_click: 'write_a_review_click',
  read_more_about_click: 'read_more_about_click',
  read_more_review_click: 'read_more_review_click',
  show_more_reviews_click: 'show_more_reviews_click',
  listing_click: 'listing_click',
  see_all_listings_button_click: 'see_all_listings_button_click',
  nearby_dealership_click: 'nearby_dealership_click',
};

export const SlideshowEventType = {
  next_image_click: 'next_image_click',
  back_image_click: 'back_image_click',
  next_image_text: 'next_image_text',
};

export const SocialSharing = {
  facebook: 'facebook',
  copy: 'copy',
  twitter: 'twitter',
  email: 'email',
  share_text: 'share_text',
};

export enum ApiType {
  requestSent = 'request_sent',
  responseSuccess = 'response_success',
  responseFailure = 'response_failure',
}
